import { render } from "./DocExpense.vue?vue&type=template&id=18de1ea5&scoped=true&ts=true"
import script from "./DocExpense.vue?vue&type=script&lang=ts"
export * from "./DocExpense.vue?vue&type=script&lang=ts"

import "./DocExpense.vue?vue&type=style&index=0&id=18de1ea5&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18de1ea5"]])

export default __exports__